"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fabricateCommunitySpend = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const validate_input_1 = require("../../utils/validate-input");
const address_1 = require("../../utils/validation/address");
const fabricateCommunitySpend = ({ address, recipient, amount, }) => (addressProvider) => {
    validate_input_1.validateInput([address_1.validateAddress(address)]);
    const community = addressProvider.community();
    return [
        new terra_js_1.MsgExecuteContract(address, community, {
            spend: {
                recipient,
                amount: new terra_js_1.Int(new terra_js_1.Dec(amount).mul(1000000)).toString(),
            },
        }),
    ];
};
exports.fabricateCommunitySpend = fabricateCommunitySpend;
//# sourceMappingURL=community-spend.js.map